import React from 'react';
import {Field, useField} from 'formik';


export const CheckboxListField = ({label, errors, name, items, customClass = ''}) => {
    const groupClass = `wizardStepCheckboxGroup ${customClass}`
    const [ field, meta ] = useField(name)

    return (
        <div role="group" aria-labelledby="checkbox-group" className='wizardCheckboxGroup' >
            <div className='wizardStepFormGroupLabel'>
                {label}
            </div>
            <div className={groupClass} >
                {items.map(item => (
                    <label key={item} className='checkboxLabel'>
                        <Field type="checkbox" name={name} value={item} />
                        {item}
                    </label>
                ))}
            </div>
            {meta.touched && meta.error && <span className='invalid-feedback' style={{display: 'block'}}>{meta.error}</span>}
        </div>
    )
}